import { SimulationConfig } from '@/domaine/SimulationConfig'

export const configDéclarationRevenusPAMC: SimulationConfig = {
	situation: {
		'déclaration revenus PAMC': 'oui',
	},
	'unité par défaut': '€',
}
